{
  "male": [
    "Jan Claesz de Dove",
    "Dirck Pietersz Halfhout",
    "Willem Gielisz Bierkan",
    "Heyn Jacobsz Coppen",
    "Cornelis Woutersz Taai",
    "Claes Jansz Rooneus",
    "Pieter Dircxz Lange",
    "Gielis Heynsz Scheel",
    "Wouter Claesz Vettebroot",
    "Jacob Cornelisz Mager",
    "Jan Jansz Snoeck",
    "Dirc Willemsz Stoter",
    "Henric Pietersz Mortel",
    "Claes Dircxz Kreupel",
    "Willem Jansz Haerinck",
    "Pieter Claesz Corte",
    "Cornelis Jacobsz Gulsigh",
    "Jan Gielisz Buyck",
    "Gielis Woutersz Muys",
    "Dirck Heynsz Clappaert",
    "Wouter Jansz Slaperigh",
    "Jacob Pietersz Hoorendrager",
    "Jan Dircxz Botermont",
    "Heyn Cornelisz Tantlooss",
    "Claes Willemsz Zuyper",
    "Pieter Jacobsz Spoock",
    "Dirc Claesz Brouwer",
    "Willem Cornelisz Mal",
    "Jan Heynsz Wijnzack",
    "Cornelis Gielisz Knorre",
    "Gielis Jansz Ganssneus",
    "Jacob Dircxz Lamme",
    "Wouter Pietersz Gaeper",
    "Claes Heynsz Kael",
    "Pieter Woutersz Swijgher",
    "Henric Claesz Bulderaer",
    "Dirck Jacobsz Kaesboer",
    "Jan Cornelisz Goetsmoets",
    "Willem Heynsz Luy",
    "Cornelis Claesz Scheefbeen",
    "Jacob Jansz Eelvanger",
    "Gielis Pietersz Pottekijker",
    "Jan Woutersz Clompe",
    "Claes Gielisz Dickhooft",
    "Pieter Heynsz Rammelaer",
    "Dirc Gielisz Hollebolle",
    "Wouter Dircxz Ongecamt",
    "Heyn Willemsz Proever",
    "Jan Jacobsz Sonder Gelt",
    "Cornelis Pietersz Nimmernuchter",
    "Jacob Claesz Bonsel"
  ],
  "female": [
    "Maria Jansdr de Kijfster",
    "Alijt Claesdr Snatersmont",
    "Lijsbeth Dircxdr Rapp",
    "Margriet Pietersdr Lange",
    "Katrijn Willemsdr Scherp",
    "Anna Cornelisdr Tantloos",
    "Neeltje Jacobsdr Vet",
    "Geertruijt Heynsdr Kael",
    "Trijn Gielisdr Waschvrou",
    "Maritgen Woutersdr Gluurster",
    "Aleid Jansdr Brouwster",
    "Lisebette Claesdr Taai",
    "Margareta Dircxdr Hooch",
    "Catharina Pietersdr Coppen",
    "Anne Willemsdr Stille",
    "Neel Cornelisdr Corte",
    "Giertje Jacobsdr Melckmeyt",
    "Maria Heynsdr Gulsigh",
    "Alijt Gielisdr Haeringwijf",
    "Lijsbeth Woutersdr Cramer",
    "Katrijn Jansdr Scheel",
    "Trijn Claesdr Bulderaer",
    "Anna Dircxdr Zuypster",
    "Margriet Cornelisdr Kreupel",
    "Neeltje Pietersdr Mager",
    "Geertruijt Willemsdr Kaeskop",
    "Aleydis Jacobsdr Spoock",
    "Maritgen Heynsdr Rooneus",
    "Lisebette Gielisdr Luy",
    "Catharina Woutersdr Klappei",
    "Maria Claesdr Sonder Man",
    "Anne Jansdr Botermont",
    "Trijn Dircxdr Ongecamt",
    "Neel Jacobsdr Snoeck",
    "Giertje Cornelisdr Dove",
    "Margareta Heynsdr Buyck",
    "Alijt Pietersdr Lamme",
    "Lijsbeth Willemsdr Hollebolle",
    "Katrijn Gielisdr Nimmerstil"
  ]
}
